import * as React from 'react';

import styles from './Gallery.css';
import { FotoramaContainer } from '../../../containers/Fotorama';
import { GalleryControlsContainer } from '../../../containers/Gallery';
import { GalleryPlaceholderContainer } from '../../../containers/GalleryPlaceholder';

export const Gallery = () => (
  <div className={styles['photo_gallery_container']} id="photos">
    <GalleryPlaceholderContainer />
    <FotoramaContainer />
    <GalleryControlsContainer />
  </div>
);
